import React, { Component } from 'react';
import classes from './OtpVerification.css';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';
import Message from '../../../../components/Message/Message';
import VerifyOTP from './VerifyOTP';
import { SESSION_SUPERUSER, SESSION_SUPERVISORUSER } from '../../../../shared/Constants';

export class OtpVerification extends Component {

    state = {
        showModal: false,
        popUpMessage: null,
        message: null,
        errMessage: null,
        submitButton: null,
        formData: null,
        formHeader: null,
        genTokenResponse: null,
        smsOtpMessage: null,
        otpGenerated: false
    }

    generateOtpToken = (otpType, otherFormDetails) => {
      if (otpType === 'Phone' || otpType === 'Call') {
          let formData = {
             uuid: this.props.healthSafeId?this.props.healthSafeId:this.props.essoData.uuid,
             phoneNo: otherFormDetails.phoneNumber && otherFormDetails.phoneNumber !== this.props.essoData.phone.number ? 
             otherFormDetails.phoneNumber : this.props.essoData.phone.number,
            phoneType: this.props.essoData.phone.label === 'MOBILE' ? "true" : "false",
            userId:this.props.essoData.userName,
            countryCode: otherFormDetails.countryCode && otherFormDetails.countryCode !== this.props.essoData.phone?.countryCode ?
            otherFormDetails.countryCode : this.props.essoData.phone?.countryCode,
            essoNumber: this.props.essoData.phone?.number,
            essoCountryCode: this.props.essoData.phone?.countryCode,
            otpMethod: otpType === 'Phone' ? 'sms' : 'call',
      }
      if(otherFormDetails.firstName && otherFormDetails.firstName !== this.props.essoData.firstName) {
        formData.firstName = otherFormDetails.firstName
      }
      if(otherFormDetails.lastName && otherFormDetails.lastName !== this.props.essoData.lastName) {
        formData.lastName = otherFormDetails.lastName
      }
       //console.log("sending otp to sms");
        this.props.generateSmsOtpToken(formData, otpType);
      } else {
          let formData = {
           userId: this.props.healthSafeId?this.props.healthSafeId:this.props.essoData.uuid,
           emailId: this.props.essoData.email.value,
           userName:this.props.essoData.userName
         }
         //console.log("sending otp to email");
        this.props.generateEmailOtpToken(formData);
  }
}

    render () {     
        //TODO: We need to uncommnet these once otp funcationality works fine.
        let otpVerificationButtons = (
            <VerifyOTP
                    generateOtpToken={this.generateOtpToken}
                    verifyOtpToken={this.verifyOtpToken}
                    essoData={this.props.essoData}
                    verifySmsOtpToken={this.props.verifySmsOtpToken}
                    verifyEmailOtpToken={this.props.verifyEmailOtpToken}
                    setOtpDisplayMessage={this.props.setOtpDisplayMessage}
                    genTokenResponse={this.props.genTokenResponse}
                    isOTPVerified={this.props.isOTPVerified}
                    userType={this.props.userType}
                    otpGenerated={this.props.otpGenerated}
                    enableAttest={this.props.enableAttest}
                    initiateAttest={this.props.initiateAttest}
                    disableConfirm={this.props.disableConfirm}
                    smsOtpMessage={this.props.smsOtpMessage}
                    idType={this.props.idType}
                />
        );
        const smsOtpMessage = this.props.smsOtpMessage?<Message msgType={this.props.smsOtpMessage.type} info={this.props.smsOtpMessage.info}
        //  position={this.props.isOTPVerified && ![SESSION_SUPERUSER, SESSION_SUPERVISORUSER].includes(this.props.userType) ? 'messageContainer':''}
         />:null;

        return (
            <div className={classes.OtpVerification}>

                <div className={classes.OTPVerification}>
                    {otpVerificationButtons}
                    {smsOtpMessage}
                </div>
                {/* <div className={classes.OTPVerificationMessageContainer}>
                    {smsOtpMessage}
                </div> */}
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        essoData: state.member.member.essoData,
        healthSafeId: state.member.member.healthSafeId,
        portalsList: state.personalInfo.portals,
        portalsInfo: state.personalInfo.portalsInfo,
        spinnerProcessing: state.member.spinnerProcessing,
        // message: state.member.resetAccountMessage,
        // errMessage: state.member.resetAccountErrMessage,
        popUpMessage: state.personalInfo.popUpMessage,
        genTokenResponse: state.member.genTokenResponse,
        smsOtpMessage: state.member.smsOtpMessage,
        otpGenerated: state.member.otpGenerated,
        enableAttest: state.member.enableAttest,
        disableConfirm: state.member.disableConfirm,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        modalSpinnerStart: () => dispatch(actions.modalSpinnerStart()),
        verifyEmailorPhone: (userData) => dispatch(actions.verifyEmailorPhone(userData)),
        setMemPopUpDisplayMessage: (message) => dispatch(actions.setMemPopUpDisplayMessage(message)),
        generateEmailOtpToken: (userData) => dispatch(actions.generateEmailOtpToken(userData)),
        generateSmsOtpToken: (userData, otpType) => dispatch(actions.generateSmsOtpToken(userData, otpType)),
        verifySmsOtpToken: (userData, essoDetails) => dispatch(actions.verifySmsOtpToken(userData,essoDetails)),
        verifyEmailOtpToken: (userData) => dispatch(actions.verifyEmailOtpToken(userData)),
        setOtpDisplayMessage: (message) => dispatch(actions.setOtpDisplayMessage(message)),
        initiateAttest: (data, essoData, userType) => dispatch(actions.initiateAttest(data, essoData, userType)),
        // setOtpGeneratedFlag: (flag) => dispatch(actions.setOtpGeneratedFlag(flag))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerification);
